// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var expandIconWrapperStyle = css({
  marginLeft: "var(--ds-space-negative-100, -8px)"
});

/**
 * @private
 * @deprecated use `import { ToolbarExpandIcon } from '@atlaskit/editor-common/ui';` instead
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var expandIconContainerStyle = css({
  display: 'flex',
  alignItems: 'center'
});
var prefix = 'ak-editor-expand';
export var expandClassNames = {
  prefix: prefix,
  expanded: "".concat(prefix, "__expanded"),
  titleContainer: "".concat(prefix, "__title-container"),
  inputContainer: "".concat(prefix, "__input-container"),
  iconContainer: "".concat(prefix, "__icon-container"),
  icon: "".concat(prefix, "__icon"),
  iconButton: "".concat(prefix, "__icon-button"),
  iconSvg: "".concat(prefix, "__icon-svg"),
  titleInput: "".concat(prefix, "__title-input"),
  content: "".concat(prefix, "__content"),
  type: function type(_type) {
    return "".concat(prefix, "__type-").concat(_type);
  }
};